import { FC, useCallback, useMemo } from 'react';
import { APP_ROUTES } from '../../routes';
import { useUrls } from 'common';
import { DataStore } from '~/store';
import { pdfDownloadMessage } from '~/utils/pdf-download-message';
import { API } from '@xbto/api-client';
import { MainFooter } from '@xbto/universal-components';

export const XbtoFooter: FC = () => {
  /**
   * Store
   */
  const getFees = DataStore.useStoreActions(a => a.settings.getFees);

  /**
   * Vars
   */
  const { faqUrl, privacyUrl, termsUrl } = useUrls();
  const onPressFees = useCallback(async () => {
    const { isSuccessful, result, errorMessage } = await getFees({
      type: API.OrganizationDocumentType.FeeSchedule,
    });

    pdfDownloadMessage(
      isSuccessful,
      result?.url,
      errorMessage,
      'view',
      errorMessage || 'Could not download Fees schedule'
    );
  }, []);

  const items = useMemo(() => {
    return [
      { label: 'Fees', onPress: onPressFees },
      { label: 'Support & FAQs', url: faqUrl },
      { label: 'Contact us', url: APP_ROUTES.NON_AUTH_CONTACT_US },
      { label: 'Terms of use', url: termsUrl },
      { label: 'Privacy policy', url: privacyUrl },
    ];
  }, [onPressFees, faqUrl, termsUrl, privacyUrl]);

  /**
   * DOM
   */
  return <MainFooter items={items} />;
};
